export const firebaseConfig = {
    apiKey: "AIzaSyCtTTIp3W6ES4SrEBM4jFalogpWcYpTpNM",
    authDomain: "burj-al-arob-0.firebaseapp.com",
    projectId: "burj-al-arob-0",
    storageBucket: "burj-al-arob-0.appspot.com",
    messagingSenderId: "344615174695",
    appId: "1:344615174695:web:42e456f3f3da6d6c43c402"
  };